import * as assert from 'assert';

export interface INewViewHistory {
    artifact_id?: number;
    collection_id?: number;
}

export interface INewArtifactViewHistory {
    artifact_id: number;
}

export interface INewCollectionViewHistory {
    collection_id: number;
}

export interface IViewHistory extends INewViewHistory {
    _id: string;
    user_id: number;
    last_viewed: number; // UNIX timestamp
}

export class ViewHistory implements IViewHistory {
    public _id: string;
    public user_id: number;
    public artifact_id?: number;
    public collection_id?: number;
    public last_viewed: number;

    public constructor(args: IViewHistory) {
        assert(args);
        assert(typeof args._id === 'string', 'invalid _id on ViewHistory');
        assert(typeof args.user_id === 'number', 'invalid user_id on ViewHistory');
        assert(typeof args.last_viewed === 'number', 'invalid last_viewed formatting on ViewHistory');

        if (args.artifact_id && !args.collection_id) {
            assert(typeof args.artifact_id === 'number', 'invalid artifact_id formatting on ViewHistory');
        } else if (args.collection_id && !args.artifact_id) {
            assert(typeof args.collection_id === 'number', 'invalid collection_id formatting on ViewHistory');
        } else {
            assert(false, 'encountered ViewHistory record with both collection_id and artifact_id');
        }

        this._id = args._id;
        this.user_id = args.user_id;
        this.artifact_id = args.artifact_id;
        this.collection_id = args.collection_id;
        this.last_viewed = args.last_viewed;
    }
}



// WEBPACK FOOTER //
// ./src/_interfaces/ViewHistory.ts